'use client';

import type { TaskFile } from '@/entities/interview-task';
import { Button } from '@/shared';
import { Dialog } from '@/shared/ui/dialog';

type SubmitConfirmDialogProps = {
	files: TaskFile[] | null;
	onClose: () => void;
	onConfirm: () => void;
};

export function SubmitConfirmDialog({
	files,
	onClose,
	onConfirm,
}: SubmitConfirmDialogProps) {
	if (!files) return null;
	return (
		<Dialog
			open
			onClose={onClose}
			title="Отправить на проверку"
			footer={
				<div className="space-y-4 px-4 pb-8 pt-2 sm:px-10">
					<Button onClick={onConfirm} block>
						Отправить на проверку
					</Button>
					<Button variant="outline" onClick={onClose} block>
						Отмена
					</Button>
				</div>
			}
		>
			<div className="px-4 py-6 sm:px-10">
				<p className="text-sm text-gray-3">
					{files.map((f, i) => (
						<span key={f.name}>
							<code className="rounded bg-gray-5 px-1 py-0.5 text-sm text-black">
								{f.name}
							</code>
							{i < files.length - 1 ? ' и ' : ''}
						</span>
					))}{' '}
					будут отправлены на проверку. Убедись, что изменения внесены во все
					нужные файлы.
				</p>
			</div>
		</Dialog>
	);
}
